import React from 'react';
import { groupBy } from 'lodash/fp';
import { Box } from '@material-ui/core';
import { SidebarContainer } from '../../../../ui-kit';
import { keyById } from '../../../../utils';
import Timeline from '../Timeline/Timeline';
import { ErrorBoundary } from '../../../shared';
import { OrderComponent } from '../../../../generated/graphql';
import OrderBillList from './OrderBillList';
import OrderSidebar from './OrderSidebar';

interface OrderDetailProps {
    orderId: string;
    activeTab: 'details' | 'timeline';
}

const OrderDetail = ({ orderId, activeTab }: OrderDetailProps) => {
    return (
        <OrderComponent variables={{ id: orderId }}>
            {({ data: { order } }) => {
                const { orderLines, bills } = order;
                const keyedBills = keyById(bills);

                const grouped = groupBy('orderLineState', orderLines);

                return (
                    <Box display='flex' flexWrap='wrap' flexGrow={1}>
                        <SidebarContainer>
                            <OrderSidebar order={order} />
                        </SidebarContainer>
                        {activeTab === 'details' ? (
                            <OrderBillList keyedBills={keyedBills} grouped={grouped} />
                        ) : (
                            <ErrorBoundary>
                                <Box display='flex' flexGrow={1} justifyContent='center'>
                                    <Timeline orderId={orderId} />
                                </Box>
                            </ErrorBoundary>
                        )}
                    </Box>
                );
            }}
        </OrderComponent>
    );
};

export default OrderDetail;
